import React from 'react'
import styles from 'styles/components/ReportTypeTag.module.sass'

interface ReportTypeTagProps {
    type: "Standard" | "Flagship" | "Free";
}

/**
 * ReportTypeTag component to display the type of report
 * @param type - Props containing the type of report
 * @returns JSX.Element
 *
 * @example
 * <ReportTypeTag type="Standard" />
 * <ReportTypeTag type="Flagship" />
 */
const ReportTypeTag: React.FC<ReportTypeTagProps> = ({ type }) => {
    return (
        <span className={`${styles['report-type-tag']} ${styles[type.toLowerCase()]}`}>
            {type}
        </span>
    );
}

export default ReportTypeTag;
